webpackJsonp([183722215743219],{

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactMarkdown = __webpack_require__(22);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _core = __webpack_require__(17);
	
	var _styled = __webpack_require__(18);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardWrapperGrid = (0, _styled2.default)(_core.Grid)(function (theme) {
	  return {
	    container: true,
	    spacing: 16,
	    fontSize: '0.75em'
	  };
	});
	
	var CardGrid = (0, _styled2.default)(_core.Grid)(function (theme) {
	  return {
	    textAlign: 'center'
	  };
	});
	
	var overal = '\nMe korraldame ka avalikke s\xFCndmuseid. Leiate meie s\xFCndmuste seast endale sobiliku seikluse. On v\xF5imalik osaleda nii individuaalselt kui ka kogu perega.\n';
	
	var Services = function Services(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(
	      _core.Grid,
	      { item: true, xs: 12, sm: 8 },
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Pereseiklus - Suusa & laua n\xE4dalavahetus V\xF5nnus (C\u0113sis, L\xE4ti) 15-16 veebruar 2020' }),
	      _react2.default.createElement(
	        CardWrapperGrid,
	        { id: 'events', container: true, justify: 'center', spacing: 16 },
	        _react2.default.createElement(
	          'iframe',
	          { src: 'https://docs.google.com/forms/d/e/1FAIpQLScyu0V2WIK4ej66YQFH_oA99PcAPOqUQTSUDGNlfSQHPNPIeA/viewform?embedded=true', width: '650', height: '2550', frameborder: '0', marginheight: '0', marginwidth: '0' },
	          'Loading...'
	        )
	      )
	    )
	  );
	};
	exports.default = Services;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ozolkalns-js-0b1f45e316a21d1bbb9a.js